<template>
  <div
    class="dm-logo-container"
    :class="`dm-size-${size}`"
  >
    <div class="dm-emblem">
      <div
        class="dm-particle"
        style="top:-4px;left:20px;animation-delay:1s"
      />
      <div
        class="dm-particle"
        style="top:10px;right:-4px;animation-delay:1s"
      />
      <div
        class="dm-particle"
        style="bottom:-4px;left:20px;animation-delay:2s"
      />
      <div
        class="dm-particle"
        style="bottom:-3px;right:2px;animation-delay:3s"
      />
      <svg
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            :id="gradientId"
            gradientUnits="objectBoundingBox"
            x1="0"
            y1="0"
            x2="1"
            y2="0"
          >
            <stop
              offset="0%"
              stop-color="#00c6ff"
            />
            <stop
              offset="100%"
              stop-color="#0046ff"
            />
            <animateTransform
              attributeName="gradientTransform"
              type="rotate"
              from="0"
              to="360"
              dur="6s"
              repeatCount="indefinite"
            />
          </linearGradient>
        </defs>
        <circle
          cx="32"
          cy="32"
          r="30"
          fill="none"
          :stroke="`url(#${gradientId})`"
          stroke-width="4"
        />
        <line
          x1="32"
          y1="12"
          x2="32"
          y2="52"
          stroke="#0072ff"
          stroke-width="4"
          stroke-linecap="round"
        />
        <line
          x1="12"
          y1="32"
          x2="52"
          y2="32"
          stroke="#00c6ff"
          stroke-width="4"
          stroke-linecap="round"
        />
        <line
          x1="20"
          y1="20"
          x2="44"
          y2="44"
          stroke="#2c88ff"
          stroke-width="4"
          stroke-linecap="round"
        />
        <line
          x1="44"
          y1="20"
          x2="20"
          y2="44"
          stroke="#2c88ff"
          stroke-width="4"
          stroke-linecap="round"
        />
      </svg>
    </div>
    <div class="dm-logo-text">
      Dark Matter
    </div>
  </div>
</template>

<script>
let uid = 0;

export default {
  name: "DarkMatterLogo",
  props: {
    size: {
      type: String,
      default: "navbar",
      validator: (value) => ["navbar", "hero"].includes(value),
    },
  },
  data() {
    uid += 1;
    return { gradientId: `dm-grad-animated-${uid}` };
  },
};
</script>

<style scoped>
.dm-logo-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.dm-emblem {
  position: relative;
}

.dm-emblem svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 0 8px rgba(0, 114, 255, 0.8));
  animation: dm-pulse-glow 3s ease-in-out infinite;
}

.dm-particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #00c6ff;
  border-radius: 50%;
  opacity: 0.8;
  animation: dm-float-particle 8s ease-in-out infinite;
}

.dm-logo-text {
  font-weight: bold;
  background: linear-gradient(120deg, #00c6ff, #0072ff, #2c88ff, #0046ff);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  text-transform: uppercase;
  animation: dm-gradient-anim 3s ease infinite;
  background-size: 300% 100%;
  white-space: nowrap;
}

/* Navbar variant — matches darkmatter.financial header */
.dm-size-navbar {
  gap: 8px;
}

.dm-size-navbar .dm-emblem {
  width: 26px;
  height: 26px;
}

@media (min-width: 640px) {
  .dm-size-navbar .dm-emblem {
    width: 32px;
    height: 32px;
  }
}

.dm-size-navbar .dm-logo-text {
  font-size: 15px;
  letter-spacing: 1.5px;
}

@media (min-width: 640px) {
  .dm-size-navbar .dm-logo-text {
    font-size: 18px;
    letter-spacing: 2px;
  }
}

/* Hero variant — for login + auth screens */
.dm-size-hero {
  flex-direction: column;
  gap: 16px;
}

.dm-size-hero .dm-emblem {
  width: 96px;
  height: 96px;
}

.dm-size-hero .dm-particle {
  width: 6px;
  height: 6px;
}

.dm-size-hero .dm-logo-text {
  font-size: 28px;
  letter-spacing: 4px;
}

@media (min-width: 640px) {
  .dm-size-hero .dm-logo-text {
    font-size: 34px;
    letter-spacing: 5px;
  }
}

@keyframes dm-float-particle {
  0% {
    transform: translate(0, 0);
    opacity: 0.8;
  }
  50% {
    transform: translate(5px, -5px);
    opacity: 0.6;
  }
  100% {
    transform: translate(0, 0);
    opacity: 0.8;
  }
}

@keyframes dm-pulse-glow {
  0%,
  100% {
    filter: drop-shadow(0 0 8px rgba(0, 114, 255, 0.8));
  }
  50% {
    filter: drop-shadow(0 0 16px rgba(0, 114, 255, 1));
  }
}

@keyframes dm-gradient-anim {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
